import { useBlocker } from "react-router";

interface UsePromptProps {
  shouldBlock: boolean;
  message: string;
}

export function usePrompt({ shouldBlock, message }: UsePromptProps) {
  const blocker = useBlocker(shouldBlock);

  if (blocker.state === "blocked") {
    const proceed = window.confirm(message);
    if (proceed) {
      blocker.proceed();
    } else {
      blocker.reset();
    }
  }
}
